import React from 'react'
import styles from './OrdersList.module.scss'
import OrdersTable from './OrdersTable/OrdersTable'
import { withRouter } from 'react-router-dom'
import OrderManager from '../OrderManager/OrderManager'

function OrdersList({ ...router }) {
  const { orderId } = router.match.params

  return (
    <div className={styles.root}>
      {!orderId && <OrdersTable />}
      {orderId && <OrderManager />}
    </div>
  )
}

export default withRouter(OrdersList)
